// extracted by css-extract-rspack-plugin
export default {"MergeQueueSectionText":"MergeQueueEntry-module__MergeQueueSectionText__ytzaD"};